import type { CommonContentProps } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderSettings/Content/types';
import SelectSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/SelectSetting';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';

const PostsContent = ({
  dataTypesOptions,
  item,
  nbItemsSliderOptions,
  onChange,
}: Omit<CommonContentProps, 'categoriesOptions' | 'isLoading'>) => (
  <AccordionTitle key={item.id} title={__('Content settings')}>
    <SelectSetting
      item={item}
      onChange={onChange}
      options={nbItemsSliderOptions}
      settingKey="dynamicAttributes.query.numberOfItems"
      title={s__('Builder|Total number of items inside the slider')}
    />
    <InputTitle label={__('Lane name')} boxProps={{ mb: 2 }} />
    <TextSetting
      item={item}
      maxLength={100}
      onChange={onChange}
      settingKey="attributes.dynamicAttributes.headlines.posts"
      width="100%"
    />
    <SelectSetting
      disabled={dataTypesOptions.length === 1}
      item={item}
      onChange={onChange}
      options={dataTypesOptions}
      settingKey="dynamicAttributes.query.dataPostsType"
      title={s__('Builder|How do you want to fill your slider?')}
    />
  </AccordionTitle>
);

export default PostsContent;
